import React, { useState } from 'react';

import GhostButton from '../GhostButton';

import TemplateDropzone from './TemplateDropzone';

/**
 * "Or upload in bulk": the template download, and "Upload completed template",
 * which opens the drag-or-browse dropzone. onImported receives the import
 * response; the dropzone closes once a file has gone in. Without the
 * permission to import, none of it shows.
 */
export default function BulkUploadBlock({ id, templateUrl, templateLabel, importUrl, canImport, onImported }) {
    const [open, setOpen] = useState(false);
    const regionId = `${id}-dropzone`;

    if (!canImport) {
        return null;
    }

    return (
        <div className="tw-flex tw-flex-col tw-gap-y-2.5">
            <h3 className="tw-mt-5 tw-mb-0 tw-text-0.5sm tw-font-semibold tw-text-charcoal-50">{$t('Or upload in bulk')}</h3>
            <div className="tw-flex tw-flex-wrap tw-gap-2.5">
                <GhostButton as="a" href={templateUrl}>
                    {templateLabel}
                </GhostButton>
                <GhostButton expanded={open} aria-controls={regionId} onClick={() => setOpen((current) => !current)}>
                    {$t('Upload completed template')}
                </GhostButton>
            </div>
            {open && (
                <TemplateDropzone
                    id={regionId}
                    uploadUrl={importUrl}
                    onUploaded={(data) => {
                        setOpen(false);
                        onImported(data);
                    }}
                />
            )}
        </div>
    );
}
